// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollToReturns_button_39-Vk","isShown":"ScrollToReturns_isShown_26cbm","icon":"ScrollToReturns_icon_2Kd7c"};